import { ForgotPassword } from "../features/authentication/components";

const ForgotPasswordPage = () => {
    return <ForgotPassword />;
};

export default ForgotPasswordPage;
